import React,{useState,useEffect} from "react";
import { MapPin, Trash2,Plus   } from "lucide-react";
import { motion } from "framer-motion";
import {
  getCPPositionList,
  createAddressContact,
  updateAddressContact,
  deleteAddressContact,
  getAddressContact
} from "@/redux/Address/actions";
 import { useDispatch, useSelector } from "react-redux";
 import { callLoader } from "@/redux/Loader/actions";
 import { showToast } from "@/redux/Toast/actions";

function AddressListSection({
  expandedSections,
  Addresses = [],
  handleAddressSelect,
  handleDelete,
}) 

{

const [showModal, setShowModal] = useState(false);
const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];

const [form, setForm] = useState({
  firstName: "",
  lastName: "",
  phoneNumber: "",
  faxNumber: "",
  emailId: "",
  alternativeEmailId: "",
  contact_position_id: 0,
  mobileNo: "",
  createdBy: authUser?.username || "System"
});

const [contacts, setContacts] = useState([]);
const [selectedRow, setSelectedRow] = useState(null);
const [positionList, setPositionList] = useState([]);
const [editingContactId, setEditingContactId] = useState(null);
const [errors, setErrors] = useState({});

 const dispatch = useDispatch();


useEffect(() => {
 _getdataCpPositionList();
}, []);

  const _getdataCpPositionList = async () => {
      try {
        debugger;
        dispatch(callLoader(1));
        
  
        try {
          const data = await getCPPositionList(); // API call
          // console.log("CP Position List Data:", data);
          if (Array.isArray(data.data)) {
            setPositionList(data.data);
          } else {
            setPositionList([]);
          }
        } catch (error) {
          setPositionList([]);
        }
        
      } catch (error) {
      } finally {
        dispatch(callLoader(0));
      }
    };

    const fetchContacts = async (addressId) => {
      debugger;
  try {
    dispatch(callLoader(1));

    const res = await getAddressContact(addressId);

      // ✅ handle both cases (object OR array)
    if (Array.isArray(res)) {
      setContacts(res);
    } else if (res && typeof res === "object") {
      setContacts([res]);   // 🔥 wrap single object into array
    } else {
      setContacts([]);
    }

  } catch (err) {
    console.error(err);
    setContacts([]);
  } finally {
    dispatch(callLoader(0));
  }
};

const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };



const handleAdd = async () => {
  debugger;

 // 🚫 STOP if validation fails
  if (!validateForm()) {
    return;
  }


  try {
    dispatch(callLoader(1));

    const payload = {
      ...form,
      address_Id: selectedRow?.addressid || 0,
      contact_Id: editingContactId || 0,
      fullName: `${form.firstName} ${form.lastName}`,
      activeFlag: true,
      isMainEntity: false,
      createdBy: authUser?.username || "System",
      contact_position_id: Number(form.contact_position_id) || 0
    };

    let res;

    // CREATE or UPDATE
    if (!editingContactId) {
      res = await createAddressContact(payload);
    } else {
      res = await updateAddressContact(payload);
    }

    if (res?.statuscode === 200 || res?.statuscode === 201) {

      // ✅ BEST PRACTICE: always refresh from API (prevents duplicates + sync issues)
      await fetchContacts(selectedRow?.addressid);

      // reset edit mode
      setEditingContactId(null);

      // reset form
      setForm({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        faxNumber: "",
        emailId: "",
        alternativeEmailId: "",
        contact_position_id: 0,
        mobileNo: "",
        createdBy: authUser?.username || "System"
      });

      dispatch(showToast("Record saved successfully", "success", true));

    } else {
      console.error("API failed:", res);
    }

  } catch (error) {
    console.error("Error saving contact:", error);
  } finally {
    dispatch(callLoader(0));
  }
};


const validateForm = () => {
  const newErrors = {};

  if (!form.firstName?.trim()) {
    newErrors.firstName = "First name is required";
  }

  if (!form.lastName?.trim()) {
    newErrors.lastName = "Last name is required";
  }

  if (!form.emailId?.trim()) {
    newErrors.emailId = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(form.emailId)) {
    newErrors.emailId = "Invalid email format";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};


const handleClear = async () => {
  debugger;

      // reset form
      setForm({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        faxNumber: "",
        emailId: "",
        alternativeEmailId: "",
        contact_position_id: 0,
        mobileNo: "",
        createdBy: authUser?.username || "System"
      });
   
};



const handleEdit = (contact) => {

  setEditingContactId(contact.contact_Id); // 👈 important

  setForm({
    firstName: contact.firstName || "",
    lastName: contact.lastName || "",
    phoneNumber: contact.phoneNumber || "",
    faxNumber: contact.faxNumber || "",
    emailId: contact.emailId || "",
    alternativeEmailId: contact.alternativeEmailId || "",
    contact_position_id: contact.contact_position_id || 0,
    mobileNo: contact.mobileNo || "",
    createdBy: authUser?.username || "System"
  });
};


const handleDeleteContact = async (contactId) => {

  const confirmDelete = window.confirm("Are you sure you want to delete this contact?");

  if (!confirmDelete) return;

  try {
    dispatch(callLoader(1));

    const res = await deleteAddressContact(contactId); // 👈 your API


    if (res?.statuscode === 200 || res?.statuscode === 201) {
      
      // remove from UI
      setContacts((prev) =>
        prev.filter((item) => item.contact_Id !== contactId)
      );

      dispatch(showToast("Deleted successfully", "success", true));
    } else {
      console.error("Delete failed", res);
    }

  } catch (error) {
    console.error("Delete error:", error);
  } finally {
    dispatch(callLoader(0));
  }
};




  return (
    <>
      <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
        <div className="bg-slate-700 p-4">
          <h3 className="text-base font-semibold text-white flex items-center gap-2">
            <MapPin className="w-5 h-5" />
            Address List
          </h3>
        </div>
        {expandedSections.s5 && (
          <div className="p-4 border-t border-slate-200 dark:border-slate-800">
            <div className="overflow-x-auto flex-1">
              <table className="w-full text-xs">
                <thead className="sticky top-0">
                  <tr className="border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50">
                    <th className="px-2 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">
                      Company Name
                    </th>
                    <th className="px-2 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">
                      Office Type
                    </th>
                    <th className="px-2 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">
                      Address1
                    </th>
                    <th className="px-2 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">
                      CITY
                    </th>
                    <th className="px-2 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">
                      COUNTRY
                    </th>
                    <th className="px-2 py-3 text-center text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">
                      CANCEL
                    </th>
                     <th className="px-2 py-3 text-center text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">
                      CONTACT
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-800 ">
                  {Addresses.map((v, index) => (
                    <motion.tr
                      key={v.id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.2, delay: index * 0.03 }}
                      className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
                    >
                      <td className="px-2 py-3">
                        <button
                          type="button"
                          onClick={() => handleAddressSelect(v?.addressid)}
                          className="p-1 text-slate-500 hover:text-[#0072FF] transition-colors"
                        >
                          <span className="text-xs font-semibold text-red-600 cursor-pointer hover:underline">
                            {v?.addressname}
                          </span>
                        </button>
                      </td>
                      <td className="px-2 py-3">
                        <span className="text-xs font-semibold text-[#0072FF] cursor-pointer hover:underline">
                          {v?.officetype === 1
                            ? "Head Office"
                            : v?.officetype === 2
                              ? "Branch Office"
                              : ""}
                        </span>
                      </td>

                      <td className="px-2 py-3">
                        <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">
                          {v?.addresS1}
                        </span>
                      </td>
                      <td className="px-2 py-3">
                        <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">
                          {v?.adD_CITY}
                        </span>
                      </td>
                      <td className="px-2 py-3">
                        <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">
                          {v?.country}
                        </span>
                      </td>
                      <td className="px-2 py-3 text-center">
                        <button
                          className="p-1 text-red-500 hover:text-red-700 transition-colors"
                          type="button"
                          onClick={() => handleDelete(v?.addressid)}
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </td>
<td className="px-2 py-3 text-center">
  <button
    className="p-1 text-blue-500 hover:text-blue-700 transition-colors"
    type="button"
    onClick={() => {
  const addressId = v?.addressid || v?.address_Id;

  if (!addressId) {
    console.error("Invalid address id");
    return;
  }

  console.log("Fetching contacts for:", addressId);

  setSelectedRow(v);
  setShowModal(true);
  fetchContacts(addressId);
}}
  >
    <Plus  className="w-4 h-4" />
  </button>
</td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        

        {showModal && (
   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 dark:bg-black/70">
    
    <div className="bg-white dark:bg-slate-900 w-[900px] max-h-[90vh] overflow-y-auto rounded-lg shadow-lg border border-slate-200 dark:border-slate-700">
      {/* CONTACT DETAILS */}
      <div className="bg-white dark:bg-slate-900 rounded shadow border border-slate-200 dark:border-slate-700">
        {/* Header */}
        <div className="bg-blue-500 dark:bg-blue-600 text-white px-4 py-2 font-semibold">
          Contact Details
        </div>

        {/* Form */}
        <div className="p-4 grid grid-cols-2 gap-4 text-sm">
          <div>
           <label className="text-gray-800 dark:text-slate-200 font-medium">First Name <span className="text-red-500">*</span></label>
            <input name="firstName" value={form.firstName} onChange={handleChange} 
            className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " />
            {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
          </div>

          <div>
            <label className="text-gray-800 dark:text-slate-200 font-medium">Last Name <span className="text-red-500">*</span></label>
            <input name="lastName" value={form.lastName} onChange={handleChange} 
             className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " />
            {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
          </div>

          <div>
            <label className="text-gray-800 dark:text-slate-200 font-medium">phone #</label>
            <input name="phoneNumber" value={form.phoneNumber} onChange={handleChange} 
            className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " />
          </div>

          <div>
            <label className="text-gray-800 dark:text-slate-200 font-medium">Fax #</label>
            <input name="faxNumber" value={form.faxNumber} onChange={handleChange}  
           className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " />
          </div>

          <div>
           <label className="text-gray-800 dark:text-slate-200 font-medium">Email <span className="text-red-500">*</span></label>
            <input name="emailId" value={form.emailId} onChange={handleChange} 
            className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " />
            {errors.emailId && <p className="text-red-500 text-sm mt-1">{errors.emailId}</p>}
          </div>

          <div>
            <label className="text-gray-800 dark:text-slate-200 font-medium">Alternative Email</label>
            <input name="alternativeEmailId" value={form.alternativeEmailId} onChange={handleChange} 
          className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " />
          </div>

          <div>
            <label className="text-gray-800 dark:text-slate-200 font-medium">Position</label>
            <select name="contact_position_id" value={form.contact_position_id} onChange={handleChange} 
             className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " >
              <option value="0">SELECT POSITION</option>
              {positionList.map((item) => (
      <option key={item.positionid} value={item.positionid}>
        {item.positionname}
      </option>
    ))}
            </select>
          </div>

          <div>
            <label className="text-gray-800 dark:text-slate-200 font-medium">Mobile No #</label>
            <input name="mobileNo" value={form.mobileNo} onChange={handleChange} 
              className="w-full min-w-0 px-3 py-2 text-sm sm:text-base text-gray-900 dark:text-gray-100 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600
             rounded-md  shadow-sm  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400
             hover:border-blue-400
            " />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-3 pb-4">
          <button onClick={handleAdd} className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded">
            Save / Update
          </button>
          <button onClick={handleClear} className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded">
            Add New Contact
          </button>
         <button
  onClick={() => setShowModal(false)}
  className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded"
>
            Close
          </button>
        </div>
      </div>

      {/* CONTACT LIST */}
     <div className="bg-white dark:bg-slate-900 rounded shadow mt-6 border border-slate-200 dark:border-slate-700">
       <div className="bg-blue-500 dark:bg-blue-600 text-white px-4 py-2 font-semibold">
          Contact List
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-green-600 text-white">
              <tr>
                <th className="p-2">CONTACT NAME</th>
                <th className="p-2">POSITION</th>
                <th className="p-2">PHONE #</th>
                <th className="p-2">FAX #</th>
                <th className="p-2">EMAIL ID</th>
                <th className="p-2">ACTION</th>
              </tr>
            </thead>

            <tbody>
              {contacts.map((c, index) => (
                <tr key={index} className="border-t text-center">
                  <td className="p-2">{c.firstName} {c.lastName}</td>
                  <td className="hidden">{c.contact_position_id}</td>
                  <td>{c.positionName}</td>
                  <td>{c.phoneNumber}</td>
                  <td>{c.faxNumber}</td>
                  <td>{c.emailId}</td>
                  <td className="flex justify-center gap-2 py-2">
                  <button
  className="text-blue-500"
  onClick={() => handleEdit(c)}
>
  ✏️
</button>
                    <button
  className="text-red-500"
  onClick={() => handleDeleteContact(c.contact_Id)}
>
  ❌
</button>
                  </td>
                </tr>
              ))}

              {contacts.length === 0 && (
                <tr>
                  <td colSpan="6" className="p-3 text-gray-400 text-center">
                    No contacts added
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
)}
      </div>

      
    </>
  );
}

export default AddressListSection;
